import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'

import { apiDashboard } from 'helpers/decorators/api'
import { Note, Reason } from 'components/misc'
import { ACTIVITY_STATES, AJ_EVENT_CATEGORIES } from 'constants/enums'
import { MaterialModal } from 'components/layout'
import MODALS from 'constants/layout/modals'
import config from 'config'
import { FormattedMessage } from 'react-intl'

@apiDashboard.apiRevise()
class ReviseMessage extends Component {
  static propTypes = {
    onGetActivitiesAssessment: PropTypes.func,
    onGetActivitiesApproval: PropTypes.func,
    onGetActivitiesSignOff: PropTypes.func,
    onGetRpAssessment: PropTypes.func,
    onGetRpApproval: PropTypes.func,
    onGetRpSignOff: PropTypes.func,
    revise: PropTypes.object,
    modalObj: PropTypes.object,
    onGetAjApproval: PropTypes.func,
    onGetAjAssessment: PropTypes.func,
    onGetAjSignOff: PropTypes.func,
    onOpen: PropTypes.func,
    push: PropTypes.func,
    awardId: PropTypes.number,
    onGetPTSignOff: PropTypes.func
  }

  state = {
    ajNote: null,
    showSetupButton: false
  }

  componentDidMount() {
    const { modalObj } = this.props
    const activity = get(modalObj, 'data.activity')
    const residentialProject = get(modalObj, 'data.residentialProject')
    const journey = get(modalObj, 'data.journey')

    if (activity) {
      this.handleActivity(activity)
    } else if (residentialProject) {
      this.handleRP(residentialProject)
    } else if (journey) {
      this.handleJourney(journey)
    }
  }

  handleActivity = activity => {
    const id = get(activity, 'id')
    const activityAssessmentRequestActionId = get(
      activity,
      'activityAssessmentRequestActionId'
    )
    const activityAssessmentActionId = get(
      activity,
      'activityAssessmentActionId'
    )
    const activitySignoffActionId = get(activity, 'activitySignoffActionId')

    const activityApprovalActionId = get(activity, 'activityApprovalActionId')

    const activityState = get(activity, 'activityState.value')

    let showSetupButton = false

    if ([ACTIVITY_STATES.setup.id].includes(activityState)) {
      showSetupButton = true
      this.props.onGetActivitiesApproval(id, activityApprovalActionId)
    } else if ([ACTIVITY_STATES.in_progress.id].includes(activityState)) {
      activityAssessmentActionId &&
        this.props.onGetActivitiesAssessment(id, activityAssessmentActionId)
      activitySignoffActionId &&
        this.props.onGetActivitiesSignOff(id, activitySignoffActionId)
    } else if ([ACTIVITY_STATES.assessment.id].includes(activityState)) {
      this.props.onGetActivitiesSignOff(id, activityAssessmentRequestActionId)
    }

    this.setState({ showSetupButton })
  }

  handleRP = residentialProject => {
    const id = get(residentialProject, 'id')
    const residentialProjectAssessmentRequestActionId = get(
      residentialProject,
      'residentialProjectAssessmentRequestActionId'
    )
    const residentialProjectAssessmentActionId = get(
      residentialProject,
      'residentialProjectAssessmentActionId'
    )
    const residentialProjectApprovalActionId = get(
      residentialProject,
      'residentialProjectApprovalActionId'
    )
    const residentialProjectSignoffActionId = get(
      residentialProject,
      'residentialProjectSignoffActionId'
    )
    const state = get(residentialProject, 'state.value')

    let showSetupButton = false

    if ([ACTIVITY_STATES.setup.id].includes(state)) {
      showSetupButton = true

      this.props.onGetRpApproval(id, residentialProjectApprovalActionId)
    } else if ([ACTIVITY_STATES.in_progress.id].includes(state)) {
      residentialProjectAssessmentActionId &&
        this.props.onGetRpAssessment(id, residentialProjectAssessmentActionId)
      residentialProjectSignoffActionId &&
        this.props.onGetRpSignOff(id, residentialProjectSignoffActionId)
    } else if ([ACTIVITY_STATES.assessment.id].includes(state)) {
      this.props.onGetRpSignOff(id, residentialProjectAssessmentRequestActionId)
    }

    this.setState({ showSetupButton })
  }

  handleJourney = journey => {
    const isPrepAndTrain =
      get(journey, 'ajEventCategoryType') ===
      AJ_EVENT_CATEGORIES.trainingAndPrep.id
    const state = get(journey, 'state.value')

    let showSetupButton = false

    if (isPrepAndTrain) {
      const signOffActionId = get(journey, 'signOffActionId')

      if (state === ACTIVITY_STATES.in_progress.id) {
        this.props.onGetPTSignOff(this.props.awardId, signOffActionId)
      }
    } else {
      const id = get(journey, 'id')
      const eventApprovalActionId = get(journey, 'ajEventApprovalActionId')
      const participantEventAssessmentActionId = get(
        journey,
        'ajParticipantEventAssessmentActionId'
      )
      const participantEventAssessmentRequestActionId = get(
        journey,
        'ajParticipantEventAssessmentRequestActionId'
      )
      const participantEventSignoffActionId = get(
        journey,
        'ajParticipantEventSignoffActionId'
      )
      // const participantEventSignoffRequestActionId = get(
      //   journey,
      //   'ajParticipantEventSignoffRequestActionId'
      // )

      if ([ACTIVITY_STATES.setup.id].includes(state)) {
        showSetupButton = true
        this.props.onGetAjApproval(id, eventApprovalActionId)
      } else if ([ACTIVITY_STATES.in_progress.id].includes(state)) {
        participantEventAssessmentActionId &&
          this.props.onGetAjAssessment(id, participantEventAssessmentActionId)
        participantEventSignoffActionId &&
          this.props.onGetAjSignOff(id, participantEventSignoffActionId)
      } else if ([ACTIVITY_STATES.assessment.id].includes(state)) {
        this.props.onGetAjSignOff(id, participantEventAssessmentRequestActionId)
      }
    }

    this.setState({ showSetupButton })
  }

  handleSetup = () => {
    const { awardId, modalObj } = this.props
    const activity = get(modalObj, 'data.activity')
    const residentialProject = get(modalObj, 'data.residentialProject')
    const journey = get(modalObj, 'data.journey')

    if (activity) {
      this.props.onOpen(null)
      setTimeout(
        () => this.props.onOpen(MODALS.ADD_ACTIVITY, null, { activity }),
        200
      )
    } else if (residentialProject) {
      this.props.push(
        `${config.publicPath}/dashboard/awards/${awardId}/residential-project/${
          residentialProject.id
        }/new`
      )
      setTimeout(
        () =>
          this.props.onOpen(MODALS.ADD_RESIDENTIAL_PROJECT, null, {
            residentialProject
          }),
        300
      )
    } else if (journey) {
      this.props.onOpen(MODALS.ADD_PE_JOURNEY, null, {
        journey
      })
    }
  }

  render() {
    const { revise } = this.props

    const note = this.state.ajNote || get(revise, 'data.note')

    const reason = this.state.ajNote || get(revise, 'data.activityReviseReasonType.translationText')

    return (
      <div>
        <Note hideNodePrefix >{note || '---'}</Note>
        <Reason hideNodePrefix >{reason || '---'}</Reason>
        {this.state.showSetupButton && <Note hideNodePrefix><FormattedMessage
          id="label.enter_new_activity_and_assessor"
          defaultMessage="Click on setup button below and enter new activity and assessor."
        /></Note>}
        {this.state.showSetupButton && (
          <MaterialModal.Footer
            onClick={this.handleSetup}
            action="Setup"
            actionKey="button.setup"
          />
        )}
      </div>
    )
  }
}

export default ReviseMessage
